import React from "react";
// COMPONENTES
import { ToastContainer } from "react-toastify";
// COMPONENTES
// MATERIAL UI
import CssBaseline from "@material-ui/core/CssBaseline";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
// MATERIAL UI
// PAGES
import Auth from "./pages/Auth";
import Loader from "./pages/Loader";
import Router from "./router";
// PAGES
import { UsuarioProvider, useUsuario } from "./context/usuario-context";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#455180",
      main: "#172953",
      dark: "#00002a",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff4f3f",
      main: "#ca0015",
      dark: "#910000",
      contrastText: "#000",
    },
    text: {
      primary: "#000",
      secondary: "#000",
    },
  },
});

const AppExport = () => (
  <UsuarioProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App></App>
    </ThemeProvider>
  </UsuarioProvider>
);

function App() {
  const { dataUser, load } = useUsuario();

  if (load) {
    return <Loader />;
  }

  return (
    <>
      {!dataUser ? <Auth /> : <Router />}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </>
  );
}

export default AppExport;
